import { Fragment } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { isBooleanFalse } from "../../utils/objectUtils";
import DotBadge from "./DotBadge";
import { useNotifications } from "../../redux/ducks/notifications";

const MarkAsRead = ({ read = false }) => {
    const { markNotificationAsRead, markNotificationAsUnread } = useNotifications();

    if (isBooleanFalse(read)) {
        return (
            <Fragment>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Mark as read</Tooltip>}
                >
                    <div onClick={() => { markNotificationAsRead(); }}>
                        <DotBadge bg="info"></DotBadge>
                    </div>
                </OverlayTrigger>
            </Fragment>
        );
    } else {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Mark as unread</Tooltip>}
            >
                <div onClick={() => { markNotificationAsUnread(); }}>
                    <DotBadge bg="secondary"></DotBadge>
                </div>
            </OverlayTrigger>
        );
    }
};

export default MarkAsRead;